import type { HttpClient } from './http-client'

export abstract class ApiService {
  constructor(protected readonly http: HttpClient) {}
}
